import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=8b9009cc&"
import script from "./ProfileSection.vue?vue&type=script&lang=js&"
export * from "./ProfileSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports